import * as React from "react";
import {
  Img,
  Heading,
  Row,
  Section,
  Column,
  Container,
  Link,
} from "@react-email/components";
import { Text } from "@react-email/text";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Layout from "../components/Layout";

export const name = "EventCanceled";
export const subject = "{{event_name}} at {{venue_name}} Has Been Canceled";

const RoundedContainer = ({
  children,
  style = {},
}: {
  children: React.ReactNode;
  style?: React.CSSProperties;
}) => {
  return (
    <Container
      style={{
        borderRadius: "4px",
        marginBottom: "16px",
        border: `1px solid #333`,
        ...style,
      }}
    >
      {children}
    </Container>
  );
};

export function template({
  event_name,
  event_url,
  organization_name,
  event_image,
  cdn_url,
  display_start_at,
  full_name,
  faq_link,
  venue_name,

}: {
  event_name: string;
  event_url: string;
  organization_name: string;
  event_image: string;
  display_start_at: string;
  full_name: string;
  faq_link: string;
  venue_name: string;
  cdn_url: string;
}) {
  const firstName = full_name.split(" ")[0];

  return (
    <Layout language="en" title={event_name}>
      <Header src={`${cdn_url}/system/kyd-logo-email.png`} />
      <Container>
        <Heading as="h1" style={eventName}>
          {`${event_name} is canceled`}
        </Heading>
        <Heading as="h3" style={label}>
          Your current ticket is valid for the new date.
          <br />
          Details below.
        </Heading>
      </Container>
      <RoundedContainer>
        <Section
          style={{
            width: "100%",
            backgroundColor: "#fff",
          }}
        >
          <Row>
            <Column
              style={{
                textAlign: "left",
                paddingInline: "12px",
                paddingBlock: "16px",
                width: "60%",
              }}
            >
              <Text style={bodyText}>Hey {firstName},</Text>
              <Text style={bodyText}>
                We regret to inform you that the {event_name} show originally
                scheduled for {display_start_at}, at {venue_name} has been
                canceled due to unforeseen circumstances. We sincerely apologize
                for any inconvenience this may cause and appreciate your
                understanding.
              </Text>
              <Text style={{ ...boldText, ...bodyText }}>
                Tickets purchased for the show will be fully refunded within 5-7
                business days.
              </Text>
              <Text style={bodyText}>
                Thank you for your support, and we hope to see you at another
                show soon!
              </Text>
              <Text style={bodyText}>Best,</Text>
              <Text style={bodyText}>Team {organization_name}</Text>
            </Column>
            <Column
              style={{
                width: "40%",
              }}
            >
              <Link href={event_url}>
                <Img
                  width={"100%"}
                  style={{ marginTop: "8px", borderRadius: "4px" }}
                  src={event_image}
                />
              </Link>
            </Column>
          </Row>
        </Section>
      </RoundedContainer>
      <RoundedContainer
        style={{
          backgroundColor: "#fff",
        }}
      >
        <Text style={style.cardTitle}>Need help?</Text>
        <Section
          style={{
            marginTop: "8px",
            borderTop: "1px solid #333",
            color: "black",
            fontSize: "12px",
            padding: "8px",
            paddingTop: "16px",
          }}
        >
          <Text style={style.eventDescription}>
            Check out our <Link href={faq_link}>FAQ</Link>. For anything urgent,
            reply to this email.
          </Text>
        </Section>
      </RoundedContainer>
      <Footer cdn_url={cdn_url} />
    </Layout>
  );
}

const bodyText = {
  fontSize: "12px",
  lineHeight: "22px",
  marginBottom: "16px",
  marginTop: "0px",
  color: "black",
};

const boldText = {
  fontWeight: "bold",
};

const style: Record<string, React.CSSProperties> = {
  cardTitle: {
    color: "black",
    margin: 0,
    fontSize: "14px",
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  rowLabel: {
    verticalAlign: "top",
    color: "black",
  },
  rowValue: {
    fontWeight: "500",
    color: "black",
  },
  eventDescription: {
    fontSize: "12px",
    color: "black",
    lineHeight: "18px",
    margin: 0,
  },
};

const title = {
  fontSize: "30px",
  fontWeight: 500,
  textAlign: "center" as const,
  color: "black",
};

const eventName: React.CSSProperties = {
  ...title,
  textTransform: "uppercase",
  textAlign: "center",
};

const label = {
  ...title,
  fontSize: "18px",
  color: "#808080",
  fontWeight: "normal",
};

template.PreviewProps = {
  event_name: "Test event",
  event_url: "/static/coachella.jpg",
  start_at: new Date().toISOString(),
  ticket_type_name: "Table seat",
  quantity: "4",
  user_name: `David Barrick`,
  total_price_display: "$185.38",
  venue_name: "LPR",
  venue_address: "55 N 5th St",
  event_description: `Test **description** 23456 Here's a link to support: [https://help.kydlabs.com](https://help.kydlabs.com)`,
  faq_link: "https://help.kydlabs.com",
  event_image: "",
  logo_url: "",
  display_start_at: "",
  full_name: "",
  organization_logo: "",
};

export default template;
